import { MULTIPLE_VALUE_SELECTORS } from '@futgg/core';
var JS_FORM_SELECTOR = '.js-pilf'; // the form
var JS_POSITIONS_SELECTOR = '.js-pilf-positions'; //the options
var JS_POSITION_HIDDEN_FIELD_SELECTOR = '.js-pilf-positions-hidden'; //the hidden input
var JS_TRIGGER_SELECTOR = '.js-pilf-trigger'; //exists
var DATA_ATTR_POSITION_KEY = 'position';
var MULTIPLE_SELECT_DATA_ATTR_KEY = 'value';
var DATA_ATTR_MARKET_INITIAL_VALUE = 'initialValue';
var POSITION_SEPARATOR = ',';
var FIELD_MARKET = 'market';
var PlayerItemListFilters = /** @class */ (function () {
    function PlayerItemListFilters(formEl) {
        var _this = this;
        this.positionsEl = null;
        this.positionHiddenEl = null;
        this.positionButtonEls = [];
        this.multipleValueButtonEls = {};
        this.currentValues = {};
        this.marketEl = null;
        this.initialMarketValue = null;
        this.handleTriggerKeyUp = function (evt) {
            switch (evt.key) {
                case 'Enter':
                    evt.currentTarget.click();
                    evt.preventDefault();
                    return false;
                default:
            }
            return true;
        };
        this.handleFormSubmit = function (evt) {
            if (_this.formEl) {
                var data = new FormData(_this.formEl);
                var queryParams_1 = new URLSearchParams();
                Array.from(data).forEach(function (p) {
                    var key = p[0];
                    var value = p[1];
                    if (value !== "") {
                        queryParams_1.set(key, value.trim());
                    }
                });
                window.location.search = queryParams_1.toString();
            }
            evt.preventDefault();
            return false;
        };
        this.handlePositionClick = function (evt, tag, hiddenFieldSelector, excludedHiddenFieldSelector, label, selector, filterLabel) {
            var _a, _b, _c;
            var buttonKey = (_c = (_b = (_a = evt.currentTarget) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b[MULTIPLE_SELECT_DATA_ATTR_KEY]) !== null && _c !== void 0 ? _c : null; //currently the id of the position
            var includedInputEls = Array.from(document.querySelectorAll(hiddenFieldSelector));
            var excludedInputEls = Array.from(document.querySelectorAll(excludedHiddenFieldSelector));
            var currentValueSet;
            var excludedValueSet;
            var filterType = '';
            if (includedInputEls[0].value !== "") {
                currentValueSet = new Set(includedInputEls[0].value.split(POSITION_SEPARATOR));
            }
            else {
                currentValueSet = new Set();
            }
            if (excludedInputEls[0].value !== "") {
                excludedValueSet = new Set(excludedInputEls[0].value.split(POSITION_SEPARATOR));
            }
            else {
                excludedValueSet = new Set();
            }
            if (buttonKey) {
                if (currentValueSet.has(buttonKey) || excludedValueSet.has(buttonKey)) {
                    if (excludedValueSet.has(buttonKey)) {
                        excludedValueSet.delete(buttonKey);
                    }
                    else {
                        currentValueSet.delete(buttonKey);
                    }
                    // evt?.currentTarget?.classList.remove('button--primary');
                    filterType = 'filterRemove';
                }
                else {
                    // evt?.currentTarget?.classList.add('button--primary');
                    currentValueSet.add(buttonKey);
                    filterType = 'filterAdd';
                }
                var filterEls = Array.from(document.querySelectorAll(selector));
                filterEls.forEach(function (el) {
                    var buttonEl = el.querySelector("span[data-".concat(MULTIPLE_SELECT_DATA_ATTR_KEY, "=\"").concat(buttonKey, "\"]"));
                    if (buttonEl) {
                        if (filterType == 'filterAdd') {
                            buttonEl.classList.add('button--primary');
                        }
                        else {
                            buttonEl.classList.remove('button--primary');
                        }
                    }
                });
                if (includedInputEls) {
                    for (var i = 0; i < includedInputEls.length; i++) {
                        includedInputEls[i].value = Array.from(currentValueSet).join(POSITION_SEPARATOR);
                        excludedInputEls[i].value = Array.from(excludedValueSet).join(POSITION_SEPARATOR);
                        var customEvent = new CustomEvent(filterType, {
                            bubbles: true, detail: {
                                label: label,
                                value: buttonKey,
                                inputSelector: hiddenFieldSelector,
                                excludedInputSelector: excludedHiddenFieldSelector,
                                type: 'button-filter',
                                selector: selector,
                            }
                        });
                        includedInputEls[i].dispatchEvent(customEvent);
                    }
                }
            }
            evt.preventDefault();
            return false;
        };
        this.formEl = formEl;
        this.formEl.addEventListener('submit', this.handleFormSubmit);
        this.formEl.querySelectorAll(JS_TRIGGER_SELECTOR).forEach(function (triggerEl) {
            triggerEl.addEventListener('keyup', _this.handleTriggerKeyUp);
        });
        MULTIPLE_VALUE_SELECTORS.forEach(function (selectorMeta) {
            var selector = selectorMeta.selector, hiddenFieldSelector = selectorMeta.hiddenFieldSelector, tag = selectorMeta.tag, filterLabel = selectorMeta.filterLabel, excludedHiddenFieldSelector = selectorMeta.excludedHiddenFieldSelector;
            var multipleSelectEl = formEl.querySelector(selector);
            multipleSelectEl === null || multipleSelectEl === void 0 ? void 0 : multipleSelectEl.querySelectorAll('.button').forEach(function (buttonEl) {
                var _a;
                buttonEl.addEventListener('click', function (evt) { return _this.handlePositionClick(evt, tag, hiddenFieldSelector, excludedHiddenFieldSelector, buttonEl === null || buttonEl === void 0 ? void 0 : buttonEl.textContent, selector, filterLabel); });
                buttonEl.addEventListener('keyup', _this.handleTriggerKeyUp);
                _this.multipleValueButtonEls[tag] = (_a = _this.multipleValueButtonEls[tag]) !== null && _a !== void 0 ? _a : [];
                _this.multipleValueButtonEls[tag].push(buttonEl);
                // this.currentValues[tag] = new Set(multipleSelectHiddenEl.value ? multipleSelectHiddenEl.value.split(POSITION_SEPARATOR) : undefined);
            });
        });
    }
    return PlayerItemListFilters;
}());
export function playerItemListFiltersInit() {
    var forms = Array.from(document.querySelectorAll(JS_FORM_SELECTOR));
    forms.forEach(function (form) {
        new PlayerItemListFilters(form);
    });
}
